import React from 'react';
import {useTranslation} from "react-i18next";
import css from "./SecThree.module.scss";

const SecThree = () => {

    const {t} = useTranslation();

    return (
        <section className={css.three}>
            <div className={css.main}>
                <div className={css.up}>
                    <p>{t("webAim")}</p>
                    <p>{t("webResearch")}</p>
                    <p>{t("webBuilding")}</p>
                    <p>{t("webTest")}</p>
                    <p>{t("webConfirm")}</p>
                    <p>{t("webSupport")}</p>
                </div>
                <div className={css.down}>
                    <p>1</p>
                    <span>------------</span>
                    <p>2</p>
                    <span>------------------</span>
                    <p>3</p>
                    <span>------------------</span>
                    <p>4</p>
                    <span>--------------------</span>
                    <p>5</p>
                    <span>--------------------</span>
                    <p>6</p>
                </div>
            </div>
        </section>
    );
};

export default SecThree;